import { render } from "./PhotoIcon.vue?vue&type=template&id=432e3870"
import script from "./PhotoIcon.vue?vue&type=script&lang=js"
export * from "./PhotoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__